import { render } from "./Setting.vue?vue&type=template&id=0f4c3ee9&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=0f4c3ee9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4c3ee9"]])

export default __exports__